import uuid from 'node-uuid';

let sourceIdForSoftToken = '';
const HashcodeUtils = {
  /** Generate new sourceId */
  getSourceId() {
    const sourceId = uuid.v1();
    sourceIdForSoftToken = sourceId;
    return sourceId;
  },

  /** Use existing sourceId */
  getSourceIdForSoftToken() {
    return sourceIdForSoftToken;
  },
};

export default HashcodeUtils;
